import { render, staticRenderFns } from "./shoppingBall.vue?vue&type=template&id=495f271c&scoped=true&"
import script from "./shoppingBall.vue?vue&type=script&lang=js&"
export * from "./shoppingBall.vue?vue&type=script&lang=js&"
import style0 from "./shoppingBall.vue?vue&type=style&index=0&id=495f271c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495f271c",
  null
  
)

export default component.exports